module.exports = __webpack_public_path__ + "logotype12.png?54e8164aa7c75ade230c0485e915107f";